export const bgImage = url => ({ backgroundImage: `url('${url}')` });
